import React, { useState, useEffect } from "react";
import MainContainer from "../../common/CWrapper";
import MPHome from "./MPHome";
import MPBenefits from "./MPBenefits";
import MPBenefitDetails from "./MPBenefitDetails";
import MPSelectVehicle from "./MPSelectVehicle";
import MPFaq from "./MPFaq";

export default function MaxPro(props) {
  const [activeScreen, setActiveScreen] = useState("");
  const [basicData, setBasicData] = useState({});
  const [otpData, setOtpData] = useState({ requestId: "" });
  const [statusData, setStatusData] = useState({});
  const [fromScreen, setFromScreen] = useState("");
  const [isFromDashboard, setIsFromDashboard] = useState(false);

  function renderSwitch() {
    switch (activeScreen) {
      case "home":
        return <MPHome setActiveScreen={setActiveScreen} />;
      case "benefits":
        return (
          <MPBenefits
            setActiveScreen={setActiveScreen}
            setBasicData={setBasicData}
            setOtpData={setOtpData}
            setIsFromDashboard={isFromDashboard}
          />
        );
      case "benefitDetails":
        return (
          <MPBenefitDetails
            setActiveScreen={setActiveScreen}
            fromScreen={setFromScreen}
            setStatusData={setStatusData}
            basicData={basicData}
            navigation={props.navigation}
            otpData={otpData}
          />
        );
      case "benefitFaq":
        return (
          <MPFaq
            setActiveScreen={setActiveScreen}
            navigation={props.navigation}
          />
        );
      case "selectMPVehicle":
        return (
          <MPSelectVehicle
            setActiveScreen={setActiveScreen}
            setBasicData={setBasicData}
            navigation={props.navigation}
          />
        );
      default:
        return (
          <MPHome
            setActiveScreen={setActiveScreen}
            setBasicData={setBasicData}
            setOtpData={setOtpData}
            setIsFromDashboard={isFromDashboard}
          />
        );
    }
  }

  return (
    <>
      <MainContainer isCustInfo={activeScreen == "benefitFaq"}>
        {renderSwitch()}
      </MainContainer>
    </>
  );
}
